//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  name: 'HomeAdsenseComp',
  props: {
    list: { // 广告列表
      type: Array, default: () => []
    }
  },
  data () {
    return {
      showAd: true // 是否展示广告位
    }
  },
  computed: {
    ...mapState(['locale', 'suffix'])
  },
  methods: {
    // 处理跳转链接
    getUrl (obj = {}) {
      const { code = '', url = '', jump = 0 } = obj || {}
      let link = ''
      switch (String(jump)) {
        case '1':
          link = `https://www.wikifx.${this.suffix}/${this.locale}/dealer/${code}.html`
          break
        case '2':
          link = url
          break
        case '3':
          link = `https://www.wikifx.${this.suffix}/${this.locale}/newsdetail/${code}.html`
          break
        default: break
      }
      return link
    },
    // 统计代码
    statistics (obj = {}) {
      const { icode = '', tcode = '', url = '', jump = 0 } = obj || {}
      this.$api.common.v3Client({ Routes: 'fxad$hits' }, {
        hitsType: 1100,
        iCode: icode || tcode,
        tCode: tcode || icode,
        jumpType: jump,
        url,
        activityType: 1
      }).then(() => {}).catch(() => {})
    }
  }
}
